<div mat-dialog-content>
  {{message}}
</div>
<div mat-dialog-actions>
  <button type="button" mat-raised-button color="primary" (click)="confirm()">Yes</button>
  <button type="button" mat-raised-button color="warm" (click)="cancel()">No</button>
</div>
